import {
    executetreatOrderItem,
    getTreatOrderAllList, getTreatOrderItemList, getPatientListByName, clinicSqbTreatmentPay,
    clinicSqbTreatQueryResult, getTreatOrderPaymentReceipt
} from "@/api";
import {addDateRange, message} from "@/assets/utils/common";
import {ElMessageBox} from "element-plus";
import officialAccountQrCode from "@/assets/images/official-account-qrcode.jpg";
import baseConfig from "@/api/config";

/**
 * pending 自动轮询窗口（秒）。取 150s 的两条约束：
 * ① 不得大于后端扫码支付锁的 TTL（ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）——
 *    窗口先到点而锁还在，会出现「页面已转待人工核查、收银员想重扫却被锁挡住」的自相矛盾状态；
 * ② 必须盖住后端补查阶梯 —— pending 落地时距发起已约 60s（SCAN_REQUEST_BUDGET_MS），
 *    两跳补查（间隔 +30s / +60s）落在 pending 落地后 +30s / +90s（即发起后约 +90s / +150s）；
 *    窗口从 pending 回包起算，留 60s 余量；到点后后端已有最终结论（收敛落库或自动撤单），收银员可放心关闭。
 */
const PAY_PENDING_WINDOW_SECONDS = 150;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            tableLoading: false,
            tableData: [],
            tableHeight: 500,
            treatOrderParams:{
                projectType: null, // 诊疗项目
                orderStatus: '1', // 诊疗状态
                dppName: null, // 患者姓名
                diagnosis: null, // 诊断
                params: null
            },
            nameSelectConShow: false,
            patientRange: [],
            treatOrder: {
                dateTime: null, // 就诊时间
                avatarImg: null, // 医生头像
                dppId: null, // 医生建档的患者ID
                dppName: null, // 患者姓名
                dppSex: null, // 患者性别
                dppAge: null, // 患者年龄
                dppPhone: null, // 患者手机号
                dppIdentity: null, // 患者身份证
                dppAddress: null, // 患者身地址
                dppAllergyHistory: null, // 患者过敏史
                docId: null, // 医生ID
                diagnosis: null, // 诊断
                projectType: null, // 诊疗项目
                projectName: null, // 项目类型
                treatPrice: null, // 金额
                orderPrice: null, // 实收
                treatOrderItemList: [], // 检查治疗项目订单对应子项目记录信息
                remark: null, // 备注
            },

            treatLoading: false,
            treatOrderItem: {
                treatId: '',
            },
            treatItemData: [],
            treatmentItem: {
                itemType: null, // 项目类型
            },
            treatItemList: [],

            orderTableLoading: false,
            dateTime: null,
            dateOrderTime: '',
            orderTableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            orderlist: [],
            patientId: null,
            direction: 'rtl',

            orderId: null,
            orderWarningInfo: null,
            fileLists: [],
            imageStyles: {
                width: 90,
                height: 120,
            },
            doctorInfo: {
                name: null,
                signPic: null,
                phoneNumber: null,
                docPriceHide: 0, // 诊费 0 显示  1 隐藏
            },
            printDate: null, // 打印日期
            treatOrderDetailVisible: false, // 检查治疗单详情弹窗
            payCodeList: [], // 预览的支付码
            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部检查治疗单', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部检查治疗单', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payState: "", // 收款三态：''（未发起）/ success / pending（结果确认中）/ failed
            payChannel: "", // 收款渠道：SQB（收钱吧）/ CASH（现金）/ FREE（免费单）
            payRequesting: false, // 支付请求在途（防止重复扫码发起第二个请求）
            querying: false, // 「重新查询」在途（手动与自动轮询共用，只作并发去重）
            manualQuerying: false, // 手动「重新查询」在途：只有它会锁弹窗，自动轮询不锁
            listQuerying: false, // 列表行「查询收款结果」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            receiptLoading: false,
            receiptPreviewVisible: false,
            receiptPrintTime: '',
            paymentReceipt: {
                institutionName: null,
                patientName: null,
                patientAge: null,
                patientGender: null,
                projectName: null,
                receivedAmount: null,
                orderNo: null,
                paidAt: null,
                paymentMethod: null,
                promotion: null
            },
            receiptPromotionImageError: {officialAccount: false},
            receiptPrintInfoObj: {
                id: 'treatPaymentReceiptPrintArea',
                popTitle: '诊疗收款凭证',
                extraHead: '<style>@page{size:80mm auto;margin:4mm}.treat-payment-receipt-print{box-sizing:border-box;width:72mm;padding:3mm 2.5mm;color:#111;font-family:"Microsoft YaHei",SimSun,sans-serif;font-size:9pt;line-height:1.45}.treat-receipt-title,.treat-receipt-name,.treat-receipt-subtitle,.treat-receipt-footer{text-align:center}.treat-receipt-title{font-size:12pt;font-weight:bold}.treat-receipt-name{margin-top:1mm;font-size:14pt;font-weight:bold}.treat-receipt-subtitle{margin:.5mm 0 2mm;padding-bottom:2mm;border-bottom:1px solid #111;color:#666;font-size:7pt;letter-spacing:.7px}.treat-receipt-section{padding:1.8mm 0;border-bottom:1px dashed #777}.treat-receipt-row{display:flex;justify-content:space-between;gap:4mm;min-height:5mm}.treat-receipt-row span:last-child{text-align:right;word-break:break-all;font-weight:500}.treat-receipt-amount{display:flex;justify-content:space-between;align-items:center;margin:1.5mm 0;padding:2mm;background:#f3f4f6;font-weight:bold}.treat-receipt-amount strong{font-size:12pt}.treat-receipt-promotion{text-align:center;padding:2mm 0;border-bottom:1px dashed #777}.treat-receipt-promotion img{display:block;width:32mm;height:32mm;margin:0 auto 1mm;object-fit:contain}.treat-receipt-promotion div{font-size:8pt;font-weight:bold;white-space:nowrap}.treat-receipt-footer{padding-top:2mm;font-size:8pt}</style>',
                preview: false,
                standard: 'html5',
                beforeOpenCallback() {},
                openCallback() {},
                closeCallback() {}
            },
            removeScanListener: null // 用于存储移除扫码监听器的函数
        }
    },
    mounted() {
        this.resizeTableHeight();
        this.initScanListener();
    },
    created() {
        this.getTreatHistoryOrderList();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.stopPayPendingWatch();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    computed: {
        // 结果面板主文案：必须与后端三态/渠道一致，pending 不得渲染成失败
        payResultText() {
            if (this.payState === 'success') {
                if (this.payChannel === 'CASH') {
                    return '已现金收款';
                }
                if (this.payChannel === 'FREE') {
                    return '为免费单，无需支付';
                }
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                // 窗口到点后转「待人工核查」：仍是「未确认」，绝不能说成失败
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        },
        // 只有收钱吧渠道才允许打印收钱吧凭证（AC6）
        canPrintSqbReceipt() {
            return this.isPayed && this.payState === 'success' && this.payChannel === 'SQB';
        },
        // 只锁「请求在途」：支付请求受 axios 70s 超时封顶、手动重查是单次查单耗时，故不可关闭时长上限≈70s。
        // pending 期间放行关闭（结果未定时关窗确实会诱导重扫，但收银员不能被关在只能干等的弹窗里）——
        // 关窗后仍有列表「查询收款结果」、服务端补查阶梯与日终对账三层兜底。
        // 用 manualQuerying 而不是 querying：后者被 10s 自动轮询共用，直接锁会让弹窗每 10 秒闪一下。
        payDialogLocked() {
            return this.payRequesting || this.manualQuerying;
        },
    },
    methods: {
        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            // AC12：请求在途时再次扫码不得发起第二个请求（重复扣款风险）
            if (this.payRequesting) {
                console.warn("上一笔支付请求尚未返回，忽略本次扫码");
                return;
            }
            console.log("this.treatOrderItem.treatId >>>>" + this.treatOrderItem.treatId);
            console.log("treatOrder orderPrice >>>>" + this.treatOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            this.payRequesting = true;
            // 新一次扫码：结束上一轮 pending 窗口
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            this.payLoading = true;
            this.isPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            let params = {
                orderId: this.treatOrderItem.treatId,
                price: this.treatOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            clinicSqbTreatmentPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.applyPayResult(response, false);
            }).catch(error => {
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                // AC13：异常必须复位，弹窗不得卡在等待态
                this.payLoading = false;
                this.isWaitPayLoading = true;
                this.isPayed = false;
                this.payState = "";
                this.payChannel = "";
            }).finally(() => {
                this.payRequesting = false;
            });
        },

        /**
         * 按后端三态契约渲染收款结果：
         *   code=200 + data.payState=success + data.channel  → 已收款（渠道见 payChannel）
         *   code=601 + data.payState=pending                 → 结果确认中，既非成功也非失败
         *   其余                                             → 明确失败
         */
        async applyPayResult(response, silent) {
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = true;
            this.payErrorMsg = "";
            // POST resolve 的是 response.data（带 code/msg/data），GET 查单 resolve 的是完整 axios response，先归一化
            const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
            const data = (payload && payload.data) || {};
            const payState = data.payState;
            const channel = data.channel || "";

            if (payload && payload.code === 200 && payState === 'success') {
                this.payState = 'success';
                this.payChannel = channel;
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                message(this.paySuccessText(channel), "success");
                // AC6：现金收款 / 免费单不得打印收钱吧凭证
                if (channel === 'SQB') {
                    await this.loadPaymentReceiptAndPrint();
                }
            } else if (payload && payload.code === 601 && payState === 'pending') {
                // AC3：第三态。既不得显示成功，也不得显示失败。
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    // 首次进入 pending：开自动轮询窗口（与后端支付锁 TTL 对齐）
                    this.startPayPendingWatch();
                }
                this.payErrorMsg = this.payPendingExpired
                    ? this.pendingExpiredMessage()
                    : this.pendingMessage();
                if (!silent) {
                    message("支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = "";
                this.successPayed = false;
                this.payErrorMsg = (payload && payload.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
        },

        // 收款渠道对应的成功文案（AC5 / AC6）
        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // AC3：pending 态的「重新查询」。走只读查单接口，绝不会发起扣款，可安全重复点击。
        requeryPayResult(silent) {
            if (this.querying || !this.treatOrderItem.treatId) {
                return;
            }
            this.querying = true;
            if (!silent) {
                // 只有手动重查锁弹窗；自动轮询不锁，否则 pending 期间弹窗每 10 秒闪一下
                this.manualQuerying = true;
            }
            //silent=true 即自动轮询，作为 autoPoll 传给后端区分「机器在等」与「收银员手动查」
            clinicSqbTreatQueryResult(this.treatOrderItem.treatId, !!silent).then(response => {
                this.applyPayResult(response, silent);
            }).catch(error => {
                console.error('重新查询支付结果失败:', error);
                if (!silent) {
                    message("重新查询失败，请稍后重试", "error");
                }
            }).finally(() => {
                this.querying = false;
                this.manualQuerying = false;
            });
        },

        // 列表行「查询收款结果」：弹窗关闭后仍可从这里补查。只读查单，绝不发起扣款。
        // autoPoll 传 false：后端据此把留痕记成 manual（只有弹窗自动轮询才传 true）。
        queryListPayResult(row) {
            if (this.listQuerying || !row.id) {
                return;
            }
            this.listQuerying = true;
            clinicSqbTreatQueryResult(row.id, false).then(response => {
                const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
                const data = (payload && payload.data) || {};
                if (payload && payload.code === 200 && data.payState === 'success') {
                    message("该订单已通过收钱吧支付", "success");
                    this.getTreatHistoryOrderList();
                } else if (payload && payload.code === 601 && data.payState === 'pending') {
                    //601 是正常业务态，绝不能报 error —— 报错会诱导收银员重扫
                    message("收款结果仍未确认，请稍后再查", "warning");
                } else {
                    //含「该订单尚未发起过扫码支付，无法查询支付结果」，原样透出后端文案
                    message((payload && payload.msg) || "查询收款结果失败", "error");
                }
            }).catch(error => {
                console.error('查询收款结果失败:', error);
                message("查询收款结果失败，请稍后重试", "error");
            }).finally(() => {
                this.listQuerying = false;
            });
        },

        /**
         * 开始 pending 自动轮询：每 PAY_PENDING_POLL_INTERVAL_SECONDS 秒查一次只读查单接口，
         * 最长 PAY_PENDING_WINDOW_SECONDS 秒；到点转「待人工核查」。
         *
         * 窗口到点时后端补查阶梯已跑完（pending 落地 +90s 的自动撤单已释放支付锁；若补查没排上，
         * 锁会保留到 10 分钟 TTL），收银员可重新扫码 —— 重扫会先经后端 checkPreviousScanOrder：
         * 上一笔已 PAID 则直接报成功，仍是未定态则被保守拦截，因此「放行重扫」不会造成重复扣款。
         */
        startPayPendingWatch() {
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            this.payPendingTimer = setInterval(() => {
                // 状态已被其他路径改写（成功/失败/重置）时窗口自行结束，
                // 这样各处的重置逻辑不必逐个记得清定时器
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired();
                    return;
                }
                this.payErrorMsg = this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    // 自动轮询不弹 toast，避免每 10 秒打扰收银员一次
                    this.requeryPayResult(true);
                }
            }, 1000);
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        // 窗口到点：转「待人工核查」。绝不能说成「支付失败」—— 钱可能已经收了。
        markPayPendingExpired() {
            this.payPendingExpired = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + PAY_PENDING_WINDOW_SECONDS + " 秒仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },

        // 通过患者姓名获取患者列表
        queryPatiantListByName(queryName) {
            if (queryName !== "" && queryName !== null && queryName !== undefined) {
                this.treatOrderParams.dppName = queryName;
                getPatientListByName(queryName).then(response => {
                    this.patientInfoList = [];
                    this.patientRange = [];
                    if (response.data.code === 200) {
                        this.patientInfoList = response.data.rows;
                        if (this.patientInfoList.length > 0) {
                            this.nameSelectConShow = true;
                            this.patientInfoList.forEach(item => {
                                this.patientRange.push({
                                    dppId: item.dppId,
                                    name: item.name,
                                    sex: item.sex === '0'?'男':item.sex === '1'?'女':'未知',
                                    age: item.age,
                                    identity: item.identity,
                                    isChoose: false,
                                });
                            })
                        } else {
                            this.nameSelectConShow = false;
                        }
                    } else {
                        this.nameSelectConShow = false;
                    }
                });
            } else {
                this.nameSelectConShow = false;
                this.treatOrder.dppId = null;
                this.currentPage = 1;
                this.getTreatHistoryOrderList();
            }
        },


        loadPaymentReceiptAndPrint() {
            if (this.receiptLoading) {
                return Promise.resolve();
            }
            if (!this.treatOrderItem.treatId) {
                ElMessageBox.alert("未获取到诊疗订单编号，暂无法打印收费凭证", "支付成功提醒", {
                    confirmButtonText: "知道了",
                    type: "warning"
                }).catch(() => {});
                return Promise.resolve();
            }
            this.receiptLoading = true;
            return getTreatOrderPaymentReceipt(this.treatOrderItem.treatId).then(async response => {
                if (response.data.code !== 200 || !response.data.data) {
                    throw new Error(response.data.msg || '诊疗收款凭证数据获取失败');
                }
                this.paymentReceipt = response.data.data;
                this.receiptPrintTime = this.getDayDateNow();
                this.receiptPromotionImageError = {officialAccount: false};
                await this.$nextTick();
                await this.waitForReceiptPromotionImages();
                this.$refs.treatPaymentReceiptPrintButton.$el.click();
            }).catch(error => {
                console.error('诊疗收款凭证打印失败:', error);
                ElMessageBox.alert("订单已支付，但收费小票打印失败，请检查打印机后重试", "支付成功提醒", {
                    confirmButtonText: "知道了",
                    type: "warning"
                }).catch(() => {});
            }).finally(() => {
                this.receiptLoading = false;
            });
        },

        hasReceiptPromotion() {
            return !this.receiptPromotionImageError.officialAccount && officialAccountQrCode;
        },

        receiptOfficialAccountQrCode() {
            return officialAccountQrCode;
        },

        waitForReceiptPromotionImages() {
            const images = this.$el.querySelectorAll('.treat-receipt-promotion img');
            return Promise.all(Array.from(images).map(image => {
                if (image.complete) return Promise.resolve();
                return new Promise(resolve => {
                    image.addEventListener('load', resolve, {once: true});
                    image.addEventListener('error', resolve, {once: true});
                });
            }));
        },

        handleReceiptPromotionImageError() {
            this.receiptPromotionImageError.officialAccount = true;
            message("推广二维码加载失败，本次凭条不含该推广信息", "warning");
        },

        displayReceiptValue(value) {
            return value === null || value === undefined || value === '' ? '--' : value;
        },

        formatReceiptGender(value) {
            return value === '0' || value === 0 ? '男' : value === '1' || value === 1 ? '女' : '未知';
        },

        formatReceiptAmount(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? '￥' + amount.toFixed(2) : '--';
        },

        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
        },


        // 取消支付
        cancalPay() {
            // 等待期（请求在途 / 结果确认中）不允许关闭：结果未定时关窗会诱导收银员重扫，
            // 而扣款可能已经发生。此处同时兜住 X、点遮罩、ESC 与「取消」按钮四条关闭路径。
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
        },



        // 确定选择患者
        sureChoosePatient(dppId, patientName) {
            this.treatOrder.dppId = dppId;
            this.treatOrderParams.dppName = patientName;
            this.patientRange.forEach(itm=>{
                itm.isChoose = dppId === itm.dppId;
            })
            this.nameSelectConShow = false;
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },

        // 表格高度自适应
        resizeTableHeight() {
            setTimeout(()=>{
                if(this.$refs.multipleOrderTable){
                    this.$nextTick(() =>{
                        // 根据浏览器高度设置初始高度
                        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
                        this.tableHeight = this.$refs.multipleOrderTable.clientHeight - 190;
                    })
                }
            }, 100)
        },

        // 选择时间
        chooseDateTime(){
            addDateRange(this.treatOrderParams, this.dateTime);
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getTreatHistoryOrderList();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getTreatHistoryOrderList();
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.treatOrderParams.diagnosis = null;
            this.treatOrderParams.orderStatus = '1';
            this.treatOrderParams.projectType = null;
            this.treatOrder.dppId = null;
            this.dateTime = [];
            addDateRange(this.treatOrderParams, this.dateTime);
            this.currentPage = 1;
            this.getTreatHistoryOrderList();
        },


        // 执行检查治疗项目
        executetreatOrderItemFunc(itemId, toId, projectName) {
            this.$confirm('确定要执行当前所选项目吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                //根据工单类型筛选，已完成订单
                executetreatOrderItem(toId).then(response => {
                    console.log(response);
                    if (response.code === 200) {
                        message("所选的 " + projectName + " 项目执行成功！", "success");
                        this.qryryTreatItemList(itemId);
                    } else {
                        message("所选的 " + projectName + " 项目执行失败！原因：" + response.msg, "error");
                    }
                });
            }).catch(() => {
                console.log('用户取消切换');
            })
        },

        // 已执行提示
        executedFunc(projectName) {
            message("所选的 " + projectName + " 项目暂无法执行或已经执行完成，请核对后重试！", "warning");
        },


        // 查询检查治疗项目工单
        getTreatHistoryOrderList() {
            this.tableLoading = true;
            //根据工单类型筛选，已完成订单
            this.treatOrderParams.dppId = this.treatOrder.dppId;
            this.treatOrderParams.docId = this.treatOrder.docId;
            this.treatOrderParams.pageNum = this.currentPage;
            this.treatOrderParams.pageSize = this.pageNums;
            getTreatOrderAllList(this.treatOrderParams).then(response => {
                console.log(response);
                this.tableLoading = false;
                if (response.data.code === 200) {
                    this.totalCount = response.data.total;
                    this.tableData = response.data.rows;
                    this.treatItemData = response.data.rows.treatOrderItemList;
                    if (this.tableData.length > 0) {
                        this.tableData.forEach(item=>{
                            item.isExpandRow = false;
                            item.isExecutedNum = 0;
                            if (item.treatOrderItemList.length > 0) {
                                item.treatOrderItemList.forEach(itm=>{
                                    if (itm.excuteStatus === '1') {
                                        item.isExecutedNum++;
                                    }
                                })
                            }
                            if (item.isExecutedNum === item.treatOrderItemList.length) {
                                item.isExecutedInfo = '2';
                                item.orderStatus = '3';
                            } else if (item.isExecutedNum === 0) {
                                item.isExecutedInfo = '0';
                            } else {
                                item.isExecutedInfo = '1';
                            }

                            if (item.dppSex === "1") {
                                item.avatarImg = baseConfig.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else if (item.dppSex === "0") {
                                item.avatarImg = baseConfig.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else {
                                item.avatarImg = baseConfig.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }
                        })
                    }
                }
            });
        },


        // 打开详情展示弹窗
        expandRowDetail(items) {
            this.treatOrderDetailVisible = true;
            this.treatLoading = true;
            this.treatOrder = items;
            this.payCodeList = [];
            this.payCodeList.push(this.tencentCosUrl+items.payQrcode);
            this.treatOrderItem.treatId = items.id;
            getTreatOrderItemList(this.treatOrderItem).then(response => {
                console.log(response);
                this.treatLoading = false;
                this.treatItemData = [];
                if (response.data.code === 200) {
                    this.treatItemData = response.data.rows;
                }
            });
        },


        // 取消详情展示弹窗
        cancelTreatDetail() {
            this.treatOrderDetailVisible = false;
        },

        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
